import React,{useState, useEffect} from 'react';
import { Table, DatePicker, Button, Space, Input } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';

import './index.scss'
import Api from "../../../../api";
import {pagingParam} from "../../../../utils/defaultValue";
import {downloadFileBlob, get7DaysDate} from "../../../../utils/tool";
import SelfTable from "../../../../components/SelfTable/index"

const { RangePicker } = DatePicker;

const PersonalStudyStatistics = ({departmentList}) => {

    const defalRange = get7DaysDate();

    // 分页
    const [pagination, setPagination] = useState({
        "pageIndex": 0,
        "pageSize": 0,
        "total":0
    });
    const [sortedInfo, setSortedInfo] = useState({});
    // 查询数据
    const [searchData, setSearchData] = useState({
        ...pagingParam,
        ...defalRange
    });

    const [tableLoading, setTableLoading] = useState(false);

    const [operationData, setOperationData] = useState(defalRange);

    const [listData, setListData] = useState([]);
    
    const columns = [
        {
            title: '用户姓名',
            dataIndex: 'userName',
            width: '',
        },
        {
            title: '工号',
            dataIndex: 'userJobNum',
            width: '120px',
            align:"center",
        },
        {
            title: '所属部门',
            dataIndex: 'departmentId',
            width: '200px',
            filters: [...departmentList.filter((val, i) => {
                return val.value !== ''
            })],
            filterMultiple:false,
            filteredValue:searchData.departmentId ? [searchData.departmentId] : [],
            render:(_, record)=>{
                return record.departmentName
            },
        },
        {
            title: '阅读知识（篇）',
            dataIndex: 'readNum',
            width: '150px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'readNum' ? sortedInfo.order : null,
        },
        {
            title: '阅读时长(小时）',
            dataIndex: 'readTime',
            width: '160px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'readTime' ? sortedInfo.order : null,
        },
        {
            title: '下载知识（次）',
            dataIndex: 'downloadTime',
            width: '150px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'downloadTime' ? sortedInfo.order : null,
        },
        {
            title: '收藏知识（次）',
            dataIndex: 'collectionNum',
            width: '150px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'collectionNum' ? sortedInfo.order : null,
        },
        {
            title: '评论知识(次）',
            dataIndex: 'askQuestionTime',
            width: '150px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'askQuestionTime' ? sortedInfo.order : null,
        },
        {
            title: '记录笔记（条）',
            dataIndex: 'takeNoteTime',
            width: '150px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'takeNoteTime' ? sortedInfo.order : null,
        }
    ];

    useEffect(()=>{
        getList()
    },[JSON.stringify(searchData)])

    const getList = async() => {
        setTableLoading(true);
        const res = await Api.Statistics.getPersonalStudyStatisticsList({data:searchData});
        setTableLoading(false);
        if(res&&res.code === 0){
            let _data = res.data;
            setListData(_data.records);
            setPagination({
                "pageIndex": _data.current,
                "pageSize": _data.size,
                "total":_data.total
            });
        }else{
            setListData([]);
        }
    }

    const onChanges = (pagination, filters, sorter, extra) => {
        let newSearchData = {...searchData}
        newSearchData.typeSortMessage = sorter.field === 'readNum' ? 1:
        sorter.field === 'downloadTime' ? 2:
        sorter.field === 'collectionNum' ? 3:
        sorter.field === 'askQuestionTime' ? 7:
        sorter.field === 'takeNoteTime' ? 8:
        sorter.field === 'readTime' ? 9:'';
        
        newSearchData.sort = sorter.order === 'descend' ? 0 : sorter.order === 'ascend' ? 1 :'';
        
        setSortedInfo({
            order: sorter.order,
            columnKey: sorter.field,
        });
        
        newSearchData.pageIndex = pagination.current;
        newSearchData.pageSize = pagination.pageSize;
        for (let key in filters) {
            newSearchData[key] = filters[key] ? filters[key][0] : ''
        }
        setSearchData(newSearchData);
    };

    const dateChange = (date, dateString) => {
        let newSearchData = {...searchData}
        newSearchData.startTime = dateString[0];
        newSearchData.endTime = dateString[1];
        newSearchData.pageIndex = 1;
        setSearchData(newSearchData);
    }

    const exportFile = async() => {
        try{
            const res = await Api.Statistics.getPersonalStudyStatisticsExport({data:searchData});
            if(res){
                downloadFileBlob(res,'个人知识学习统计明细.xlsx')
            }
        }catch{
            
        }
    }

    const onSearch = () => {
        operationData.authorName = operationData.authorName ? operationData.authorName.trim(): operationData.authorName
        operationData.authorJobNum = operationData.authorJobNum ? operationData.authorJobNum.trim(): operationData.authorJobNum
        setSearchData({
            ...searchData,
            ...operationData
        });
    }

    const searchChange = (value, type) => {
        let newOperationData = {...operationData};
        if(type === "timeRange"){
            newOperationData.startTime = value[0];
            newOperationData.endTime = value[1];
        }else{
            newOperationData[type] = value;
        }
        newOperationData.pageIndex = 1;
        setOperationData(newOperationData)
    }

    const onResetting = () => {
        setOperationData({
            ...defalRange,
            authorName:"",
            authorJobNum:""
        });
        setSearchData({
            ...pagingParam,
            ...defalRange
        });
        setSortedInfo({});
    }

    const disabledDate = (current) => {
        // Can not select days after today and today
        return current && current > moment().endOf('day');
    };

    return(
        <div className="personalStudyStatisticsFrame">
            <div className="title">个人知识学习统计</div>
            <div className="operation">
                <div className="operationLeft">
                    <div className="operationItem">
                        <span>选择时段：</span>
                        <RangePicker 
                            ranges={{
                                '当天': [moment(), moment()],
                                '近7天':[moment().subtract(7, 'day'), moment()],
                                '本月': [moment().startOf('month'), moment()],
                                '近三个月': [moment().subtract(3, 'months'), moment()],
                            }}
                            disabledDate={disabledDate}
                            value={operationData.startTime?[moment(operationData.startTime), moment(operationData.endTime)]:[]}
                            onChange={(date, dateString)=>{
                                searchChange(dateString,"timeRange")
                            }}/>
                    </div>
                    <div className="operationItem">
                        <span className='operationtitle'>用户姓名：</span>
                        <Input value={operationData.authorName} onPressEnter={onSearch} placeholder='请输入用户姓名' allowClear onChange={(e)=>{
                            searchChange(e.target.value,"authorName")
                        }}/>
                    </div>
                    <div className="operationItem">
                        <span className='operationtitle'>工号：</span>
                        <Input value={operationData.authorJobNum} onPressEnter={onSearch} placeholder='请输入工号' allowClear onChange={(e)=>{
                            searchChange(e.target.value,"authorJobNum")
                        }}/>
                    </div>
                    <div className="operationItem">
                        <Space size={"large"}>
                            <Button type="primary" onClick={onSearch}>搜索</Button>
                            <Button onClick={onResetting}>重置</Button>
                        </Space>
                    </div>
                </div>
                <div className="operationRight">
                    <Space size={"large"}>
                        <Button onClick={exportFile} icon={<DownloadOutlined />}>导出</Button>
                    </Space>
                </div>
            </div>
            <div className="table">
                <SelfTable
                    dataSource={listData}
                    columns={columns}
                    pagination={pagination}
                    loading={tableLoading}
                    onChange={onChanges} 
                    scroll={
                        {
                            x:"1500px"
                        }
                    }
                />
                {/* <Table 
                    rowKey="id" 
                    columns={columns} 
                    bordered 
                    dataSource={listData} 
                    onChange={onChanges} 
                    pagination={{
                        total:pagination.total,
                        current:pagination.pageIndex,
                        pageSize:pagination.pageSize,
                        showSizeChanger:true,
                        showQuickJumper:true,
                        showTotal:()=> `总计${pagination.total}条数据`
                    }}
                    scroll={{
                        scrollToFirstRowOnChange:true,
                        y:tableHight
                    }}
                    loading={tableLoading}
                /> */}
            </div>
        </div>
    )
}
export default PersonalStudyStatistics